import React, { FC, memo } from 'react';
import styled from "styled-components";
import i18next from "i18next";
import PrimaryButton from "./PrimaryButton";

const Wrapper = styled.div`
    background: #ffffff;
    width : 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    justify-content : center;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content : center;
    align-items: center;
`;

const TitleText = styled.span`
    font-family: Montserrat;
    font-style: normal;
    font-weight: 800;
    font-size: 100px;
    line-height: 100%;
    color: #FF695F;
`;

const SubHeading = styled.span`
    font-family: Montserrat;
    font-style: normal;
    font-weight: 800;
    font-size: 28px;
    line-height: 150%;
    color: #161616;
`;

const ContentText = styled.span`
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    color: #161616;
    margin-bottom: 15px;
`;

type Props = { callback: () => {}, errorContent?: string };
const ErrorComponent: FC<Props> = ({ errorContent, callback }) => {

  return (<Wrapper>
    <Content>
      <TitleText></TitleText>
      <SubHeading>{i18next.t('errorMessageTemplate.genericTitle')}</SubHeading>
      <ContentText>{errorContent || i18next.t('errorMessageTemplate.genericMsg')}</ContentText>
      <PrimaryButton onClick={callback}>
        {i18next.t('errorMessageTemplate.retryButtonText')}
      </PrimaryButton>
    </Content>
  </Wrapper>)

};

export default memo(ErrorComponent);
